module.exports = __webpack_public_path__ + "static/media/CTLI_3-444w.6ba50599.webp";